(function(){
var $=function(s,r){return(r||document).querySelector(s)},$$=function(s,r){return[].slice.call((r||document).querySelectorAll(s))};
var money=function(c){return '0'+(c/100).toFixed(2).replace('.',',')};
function show(id){var e=document.getElementById(id);if(e)e.classList.add('show')}
function render(c){
  var h='';
  c.items.forEach(function(it,i){
    h+='<div class="it"><div class="th">'+(it.image?'<img src="'+it.image+'" alt="">':'')+'</div><div class="in">'+it.product_title+'<br>'+(it.variant_title?it.variant_title+'<br>':'')+'QTÉ : '+it.quantity+'<br><button data-rm="'+(i+1)+'">RETIRER</button></div><div>'+money(it.final_line_price)+'</div></div>';
  });
  var items=$('#items');if(items)items.innerHTML=h||'<div class="it">PANIER VIDE</div>';
  var t=$('#tot');if(t)t.textContent=money(c.total_price);
  $$('[data-count]').forEach(function(e){e.textContent=c.item_count;e.hidden=!c.item_count});
  recs(c);
}
function recs(c){
  var el=$('#cp');if(!el)return;
  if(!c.items.length){el.innerHTML='';return}
  var ids=c.items.map(function(i){return i.product_id});
  fetch('/recommendations/products.json?product_id='+ids[ids.length-1]+'&limit=6').then(function(r){return r.json()}).then(function(d){
    var p=(d.products||[]).filter(function(x){return ids.indexOf(x.id)<0}).slice(0,4);
    el.innerHTML=p.length?'<h3>COMPLÈTE LA TENUE</h3><div class="cps">'+p.map(function(x){return '<div class="cpi"><div class="th">'+(x.featured_image?'<img src="'+x.featured_image+'" alt="">':'')+'</div><div class="tx">'+x.title+'<br>'+money(x.price)+'<br><a href="'+x.url+'">VUE RAPIDE</a></div></div>'}).join('')+'</div>':'';
  }).catch(function(){el.innerHTML=''});
}
function load(){return fetch('/cart.js').then(function(r){return r.json()}).then(render)}
function change(line,q){fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:+line,quantity:q})}).then(function(r){return r.json()}).then(render)}
document.addEventListener('click',function(e){
  var t=e.target,o=t.closest('[data-open]');
  if(o){e.preventDefault();if(o.dataset.open==='cart')load();show(o.dataset.open);return}
  if(t.closest('[data-close]')){e.preventDefault();var m=t.closest('.menu,.cart,.ov');if(m){m.classList.remove('show');if(m.id==='pop'){try{localStorage.setItem('fcp','1')}catch(x){}}}return}
  var r=t.closest('[data-rm]');if(r){change(r.dataset.rm,0);return}
  var a=t.closest('.acc>button');if(a){a.parentNode.classList.toggle('open');return}
  var q=t.closest('[data-q]');
  if(q){var f=q.closest('form'),v=$('[data-qv]',f),n=Math.max(1,(+v.textContent)+(+q.dataset.q));v.textContent=n;$('[name=quantity]',f).value=n;return}
  var s=t.closest('.sz,.swb');
  if(s){
    var root=s.closest('[data-product]');
    $$('.sz,.swb',s.parentNode).forEach(function(x){x.classList.remove('on')});s.classList.add('on');if(s.classList.contains('swb')){var cn=$('[data-cname]',root);if(cn)cn.textContent=s.dataset.v}
    var vals=$$('[data-opt]',root).map(function(g){return $('.on',g).dataset.v});
    var vs=JSON.parse($('[data-variants]',root).textContent);
    var va=vs.filter(function(x){return vals.every(function(val,i){return x['option'+(i+1)]===val})})[0];
    var b=$('[data-add]',root),sp=$('span',b);
    if(va){$('[name=id]',root).value=va.id;b.disabled=!va.available;sp.textContent=va.available?'AJOUTER AU PANIER':'ÉPUISÉ';$('[data-price]',root).textContent=money(va.price)}
    else{b.disabled=true;sp.textContent='INDISPONIBLE'}
  }
});
document.addEventListener('submit',function(e){
  var f=e.target.closest('[data-product-form]');if(!f)return;
  e.preventDefault();
  fetch('/cart/add.js',{method:'POST',body:new FormData(f),headers:{Accept:'application/json'}}).then(function(r){return r.json()}).then(function(){load();show('cart')});
});
if(document.body.classList.contains('home')&&$('#pop')){try{if(!localStorage.getItem('fcp'))setTimeout(function(){show('pop')},1500)}catch(e){}}
$$('[data-gal]').forEach(function(g){var n=g.children.length,d=g.parentNode.querySelector('.dots');if(n<2||!d)return;d.innerHTML=new Array(n+1).join('<i></i>');var set=function(){var i=Math.round(g.scrollLeft/g.clientWidth);$$('i',d).forEach(function(x,k){x.className=k===i?'on':''})};g.addEventListener('scroll',set);set()});
})();
